export const CREATE_FLASHCARDS = 'CREATE_FLASHCARDS';
export const FETCH_ALL_FLASHCARDS = 'FETCH_ALL_FLASHCARDS';
export const UPDATE_FLASHCARDS = 'UPDATE_FLASHCARDS';
export const UPDATE_FLASHCARD_HEADER = 'UPDATE_FLASHCARD_HEADER';
export const DELETE_FLASHCARDS = 'DELETE_FLASHCARDS';
export const FETCH_FLASHCARD = 'FETCH_FLASHCARD';
export const FETCH_FLASHCARD_BODY = 'FETCH_FLASHCARD_BODY';
export const FETCH_ALL_FLASHCARD_HEADERS = 'FETCH_ALL_FLASHCARD_HEADERS';

export const CREATE_TRAININGS = 'CREATE_TRAININGS';
export const UPDATE_TRAININGS = 'UPDATE_TRAININGS';
export const DELETE_TRAININGS = 'DELETE_TRAININGS';
export const FETCH_ALL_TRAININGS = 'FETCH_ALL_TRAININGS';

export const FETCH_ALL_TESTS = 'FETCH_ALL_TESTS';
export const CREATE_TEST = 'CREATE_TEST';

export const FETCH_ALL_FLASHCARD_TYPES = 'FETCH_ALL_FLASHCARD_TYPES';
export const CREATE_FLASHCARD_TYPE = 'CREATE_FLASHCARD_TYPE';
export const UPDATE_FLASHCARD_TYPE = 'UPDATE_FLASHCARD_TYPE';
export const DELETE_FLASHCARD_TYPE = 'DELETE_FLASHCARD_TYPE';
